import React, { useState } from "react"
import { Row, Col, Button } from "reactstrap"

const AttendanceTabs = ({ activeTab, setActiveTab }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const toggleModal = () => setModalOpen(!modalOpen)

  const handleAbsentClick = () => {
    setActiveTab(0)
    toggleModal()
  }

  return (
    <>
      <Row
        className="justify-content-center py-2"
        style={{ backgroundColor: "#211689" }}
      >
        <Col xs="auto" className="text-center">
          <Button
            color="light"
            style={{
              color: "green",
              backgroundColor: activeTab === 1 ? "#e6ffe6" : "#fff",
              border: "1px solid green",
              borderRadius: "20px",
              padding: "6px 16px",
              marginRight: "8px",
              fontWeight: "500",
              transition: "all 0.3s ease",
              boxShadow:
                activeTab === 1 ? "0 0 6px rgba(0, 128, 0, 0.4)" : "none",
            }}
            onClick={() => setActiveTab(1)}
          >
            Present
          </Button>

          <Button
            color="light"
            style={{
              color: "red",
              backgroundColor: activeTab === 0 ? "#ffe6e6" : "#fff",
              border: "1px solid red",
              borderRadius: "20px",
              padding: "6px 16px",
              fontWeight: "500",
              transition: "all 0.3s ease",
              boxShadow:
                activeTab === 0 ? "0 0 6px rgba(255, 0, 0, 0.4)" : "none",
            }}
            onClick={handleAbsentClick}
          >
            Absent
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default AttendanceTabs
